import * as types from 'store/actions/types';
import produce from 'immer';
import { formatDateToCalendar } from '../helpers_reducers/convert_helpers';

export const INITIAL_STATE = {
	loading: true,
	error: false,
	data: [],
	columns: [],
	updateCheckedItems: {
		success: false,
		error: false
	},
	options: {
		pages: 0,
		page: 0,
		total_results: 0,
		startIndex: 0,
		sorted: undefined,
		filters: {
			query: '',
			date: formatDateToCalendar(),
			filterUrlQuery: ''
		}
	}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_PANEL_STATE:
				return { ...INITIAL_STATE };

			// *************** FETCH EPG ***************
			case types.FETCH_EPG_LOADING:
				draft.loading = true;
				draft.error = false;
				return;

			case types.FETCH_EPG_SUCCESS:
				draft.loading = false;
				draft.data = action.payload.data;
				draft.columns = action.payload.input.columns;
				draft.options.pages = action.payload.pages;
				draft.options.total_results = action.payload.recordsFiltered;
				draft.options.startIndex = action.payload.startIndex;
				draft.options.page = action.payload.page;
				return;

			case types.FETCH_EPG_ERROR:
				draft.error = action.payload;
				return;

			// *************** SEND EPG TO BLACKLIST ***************
			case types.SEND_EPG_TO_BLACKLIST_LOADING:
				draft.updateCheckedItems.success = false;
				draft.updateCheckedItems.error = false;
				return;

			case types.SEND_EPG_TO_BLACKLIST_SUCCESS:
				draft.updateCheckedItems.success = action.payload;
				draft.updateCheckedItems.error = false;
				return;

			case types.SEND_EPG_TO_BLACKLIST_ERROR:
				draft.updateCheckedItems.error = action.payload;
				return;

			// *************** SAVE SORTING OPTIONS ***************
			case types.SAVE_EPG_TABLE_SORTING:
				draft.options.sorted = action.payload;
				break;

			// *************** SET SEARCH QUERY ***************
			case types.SET_EPG_SEARCH_QUERY:
				draft.options.filters.query = action.payload;
				return;

			// *************** SET EPGS DATE ***************
			case types.SET_EPG_DATE:
				draft.options.filters.date = action.payload;
				return;

			// --------------- FILTERS ---------------
			// *************** SET FILTER URL QUERY ***************
			case types.SET_FILTER_URL_QUERY:
				draft.options.filters.filterUrlQuery = action.payload;
				break;

			// *************** CLEAR FILTERS ***************
			case types.CLEAR_FILTERS:
				draft.options.filters.filterUrlQuery = '';
				break;

			default:
				return state;
		}
	});
